import { ElementType } from 'react';

import { FileIconState } from './FileIcon.types';
import { FileIconComplete as ChatFileIconComplete } from './FileIconChat/FileIconComplete/FileIconComplete';
import { FileIconError as ChatFileIconError } from './FileIconChat/FileIconError/FileIconError';
import { FileIconHover as ChatFileIconHover } from './FileIconChat/FileIconHover/FileIconHover';
import { FileIconLoading as ChatFileIconLoading } from './FileIconChat/FileIconLoading/FileIconLoading';
import { FileIconLoadingInfinity as ChatFileIconLoadingInfinity } from './FileIconChat/FileIconLoadingInfinity/FileIconLoadingInfinity';
import { FileIconRegular as ChatFileIconRegular } from './FileIconChat/FileIconRegular/FileIconRegular';
import { FileIconComplete } from './FileIconDefault/FileIconComplete/FileIconComplete';
import { FileIconError } from './FileIconDefault/FileIconError/FileIconError';
import { FileIconHover } from './FileIconDefault/FileIconHover/FileIconHover';
import { FileIconLoading } from './FileIconDefault/FileIconLoading/FileIconLoading';
import { FileIconLoadingInfinity } from './FileIconDefault/FileIconLoadingInfinity/FileIconLoadingInfinity';
import { FileIconRegular } from './FileIconDefault/FileIconRegular/FileIconRegular';

export const FILE_ICON_DEFAULT_COMPONENTS_MAP: Record<FileIconState, ElementType> = {
  [FileIconState.Error]: FileIconError,
  [FileIconState.Hover]: FileIconHover,
  [FileIconState.Loading]: FileIconLoading,
  [FileIconState.Infinity]: FileIconLoadingInfinity,
  [FileIconState.Completed]: FileIconComplete,
  [FileIconState.Regular]: FileIconRegular,
};

export const FILE_ICON_CHAT_COMPONENTS_MAP: Record<FileIconState, ElementType> = {
  [FileIconState.Error]: ChatFileIconError,
  [FileIconState.Hover]: ChatFileIconHover,
  [FileIconState.Loading]: ChatFileIconLoading,
  [FileIconState.Infinity]: ChatFileIconLoadingInfinity,
  [FileIconState.Completed]: ChatFileIconComplete,
  [FileIconState.Regular]: ChatFileIconRegular,
};
